import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Common Entities => page template => ');

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// Fetching page templates.
const fetchPageTemplates = createAction('fetch page templates', (validFor, formatType) => ({ validFor, formatType }));
const fetchPageTemplatesFailure = createApiFailureAction('failed to fetch page templates');
const fetchPageTemplatesSuccess = createAction('succesfully fetched page templates', pageTemplates => ({
  pageTemplates,
}));

const resetPageTemplates = createAction('reset page templates');

export default {
  fetchPageTemplates,
  fetchPageTemplatesSuccess,
  fetchPageTemplatesFailure,
  resetPageTemplates,
};
